module.exports = __webpack_public_path__ + "static/media/DSCF6533.d9c50ab5.JPG";